"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
var NotificationTypeStore_1 = __importDefault(require("./Store/NotificationTypeStore"));
var NotificationType = /** @class */ (function () {
    function NotificationType(session) {
        this.notificationTypeStore = new NotificationTypeStore_1.default(session);
    }
    NotificationType.prototype.getAll = function () {
        return this.notificationTypeStore.getAll();
    };
    return NotificationType;
}());
exports.NotificationType = NotificationType;
//# sourceMappingURL=NotificationType.js.map